import { Vue, newVue, initVue } from '@/config/vue'

initVue({
  controller: 'sustainability',
  init() {
    const Sustainability = Vue.component('sustainability', () =>
      import(/* webpackChunkName: "sustainability" */ './Sustainability.vue')
    )
    newVue({
      render: h => h(Sustainability),
      mount: '.sustainability',
    })
  },
})
